import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { FC, useEffect, useMemo, useState } from "react";
import { Localizacao } from "src/apis/eezyfamily";
import NoDataAlert from "src/pages/components/NoDataAlert";

const ROWS = 10;

type Props = {
  localizacoes: Localizacao[];
  onEdit: (item: Localizacao) => void;
  onDelete: (id: number) => void;
};

const LocalizacoesTable: FC<Props> = ({
  localizacoes,
  onEdit,
  onDelete,
}): JSX.Element => {
  const hasData = useMemo(
    () => Boolean(localizacoes) && localizacoes.length > 0,
    [localizacoes]
  );
  const [entries, setEntries] = useState<Localizacao[]>(localizacoes);
  const [page, setPage] = useState(0);

  useEffect(() => {
    if (hasData) setEntries(localizacoes);
  }, [hasData, localizacoes]);

  const pageSlice = entries.slice(page * ROWS, page * ROWS + ROWS);

  if (!hasData) return <NoDataAlert />;

  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><Typography fontWeight={600}>Cidade</Typography></TableCell>
              <TableCell><Typography fontWeight={600}>Estado</Typography></TableCell>
              <TableCell align="right"><Typography fontWeight={600}>Ações</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pageSlice.map((item) => (
              <TableRow key={item.id} hover>
                <TableCell>{item.city}</TableCell>
                <TableCell>{item.state}</TableCell>
                <TableCell align="right">
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Tooltip title="Editar">
                      <IconButton
                        size="small"
                        onClick={() => onEdit(item)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton
                        size="small"
                        onClick={() => onDelete(item.id)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={entries.length}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        rowsPerPage={ROWS}
        rowsPerPageOptions={[ROWS]}
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      />
    </>
  );
};

export default LocalizacoesTable;
